import IMask from 'imask'

const phoneMask = {
  mask: '+{7} (000) 000 00 00',
  autoUnmask: true,
  lazy: false,
}

const dateMask = {
  mask: Date,
  lazy: false,
}

// Маски полей с атрибутом data-imask (форма заявки Salomat); поля без атрибута не затрагиваются.
// Код страны в маске телефона виден сразу, как и у маски phone_mask, иначе первая введённая 9 попала бы в него
export const dataMasks = {
  uz_phone: { mask: '+{998} (00) 000-00-00', lazy: false },
  uz_mfo: { mask: '00000' },
  bank_card: { mask: '0000 0000 0000 0000' },
  uz_inn: { mask: '000000000' },
  uz_pinfl: { mask: '00000000000000' },
  uz_passport: { mask: 'LL0000000', definitions: { L: /[A-Z]/ }, prepare: (value) => value.toUpperCase() },
}

// IMask переписывает значение поля при подключении. Сохранённое значение, которое маске не подходит (например, ИНН
// или номер паспорта прежнего формата), она обрезала бы молча, поэтому такое поле остаётся без маски,
// а сервер при сохранении покажет ошибку формата
const fitsMask = (value, mask) => {
  const masked = IMask.createMask(mask)
  masked.resolve(value)
  return value === '' || value === masked.value || value === masked.unmaskedValue
}

$(function() {
  $('input.phone_mask').each((_, input) => { IMask(input, phoneMask) })
  $('input.date-time-picker-input').each((_, input) => { IMask(input, dateMask) })
  $('input[data-imask]').each((_, input) => {
    const mask = dataMasks[input.dataset.imask]
    if (mask && fitsMask(input.value, mask)) IMask(input, mask)
  })
})
